var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"spaced":false,"shadow":true}},[_c('template',{slot:"brand"},[_c('b-navbar-item',[_vm._v(" Memegen ")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }